import { useActiveOrganization } from '../../contexts/auth';
import { BrandingLogoContainer } from '../../contexts/organizations';
import { PageHeader } from '../../components/page-header';

export function BrandingSettingsPage() {
  const { organization } = useActiveOrganization();

  return (
    <div className="space-y-8">
      <PageHeader
        title="Branding"
        description="Customize what candidates see during conversations with your organization."
      />
      {organization && <BrandingLogoContainer orgId={organization.id} />}
    </div>
  );
}
